export enum SystemProcessHomeAction {
  VIEW = '1',
  EDIT = '2',
  DELETE = '3',
  ROLE_ASSIGN = '4',
  PERMISSION_ASSIGN = '5',
  COPY = '6',
  PROFILE_PHOTO = '7',
  VIEW_CHANGELOG = '8',
  LOCK_MODULE = '9',
  CHANGE_PASSWORD = '10',
  INVITE_USER = '11',
}

export enum SystemStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum ApprovalListItemAction {
  VIEW = '1',
  APPROVAL_LOG = '2',
}

export enum ApprovalStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  HOLD = 'Hold',
  REJECTED = 'Rejected',
}

export enum ApprovalAction {
  APPROVE = 'Approve',
  HOLD = 'Hold',
  REJECT = 'Reject',
}

export enum FinalApprovalStatus {
  INCOMPLETE = 0,
  COMPLETE = 1,
}
export enum SelectAllOption {
  DISABLE = 0,
  ENABLE = 1,
}

export enum ExportActions {
  REPORT_SUMMARY = 'report_summary',
  CHANGE_LOG = 'change_log',
  APPROVAL_LOG = 'approval_log',
  LINE_ITEMS = 'lineItem_report',
  CONVEYANCE_SUMMARY = 'conveyance_summary',
  HANDSET_SUMMARY = 'handset_summary',
  EXPENSE_SUMMARY = 'expense_summary',
  CONSOLIDATED_VIEW = 'consolidated_view',
}

export enum DocumentType {
  INVOICE = 'INVOICE',
  QUOTATION = 'QUOTATION',
  OTHERS = 'OTHERS',
  RECEIPT = 'RECEIPT',
  CONTRACT = 'CONTRACT',
  NOC = 'NOC',
  AGREEMENT = 'AGREEMENT',
  PO_COPY = 'PO_COPY',
  EMAIL_APPROVAL = 'EMAIL_APPROVAL',
}

export const DocumentTypeLabels: Record<DocumentType, string> = {
  [DocumentType.INVOICE]: 'Invoice',
  [DocumentType.QUOTATION]: 'Quotation',
  [DocumentType.OTHERS]: 'Others',
  [DocumentType.RECEIPT]: 'Receipt',
  [DocumentType.CONTRACT]: 'Contract',
  [DocumentType.NOC]: 'NOC',
  [DocumentType.AGREEMENT]: 'Agreement',
  [DocumentType.PO_COPY]: 'PO Copy',
  [DocumentType.EMAIL_APPROVAL]: 'Email Approval',
};

export const DocumentTypeOptions = Object.values(DocumentType).map(value => ({
  value,
  label: DocumentTypeLabels[value],
}));

export const TravelAttachmentDocumentTypeOptions = [
  DocumentType.INVOICE,
  DocumentType.RECEIPT,
  DocumentType.QUOTATION,
  DocumentType.OTHERS,
].map(value => ({
  value,
  label: DocumentTypeLabels[value],
}));

export const ContractAttachmentDocumentTypeOptions = [
  DocumentType.AGREEMENT,
  DocumentType.OTHERS,
  DocumentType.EMAIL_APPROVAL,
].map(value => ({
  value,
  label: DocumentTypeLabels[value],
}));

export enum SystemApprovalAction {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  HOLD = 'HOLD',
  IN_REVIEW = 'IN_REVIEW',
  CANCEL = 'CANCEL',
}

export enum SystemApprovalStatus {
  // DRAFT = 'DRAFT',
  // SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  HOLD = 'HOLD',
  IN_REVIEW = 'IN_REVIEW',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
}

export enum SystemSubmissionStatus {
  DRAFT = 0,
  SUBMITTED = 1,
}

export const SystemApprovalStatusOptions = [
  // { label: 'Approved', value: SystemApprovalStatus.APPROVED },
  { label: 'Rejected', value: SystemApprovalStatus.REJECTED },
  { label: 'Hold', value: SystemApprovalStatus.HOLD },
  { label: 'In Review', value: SystemApprovalStatus.IN_REVIEW },
  { label: 'Pending', value: SystemApprovalStatus.PENDING },
  { label: 'Cancelled', value: SystemApprovalStatus.CANCELLED },
];

export const SystemSubmissionStatusOptions = [
  { label: 'Draft', value: SystemSubmissionStatus.DRAFT },
  { label: 'Submitted', value: SystemSubmissionStatus.SUBMITTED },
];

// Reusable Yes/No options for dropdowns
export const YesNoOptions = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
];

// Backward-compatible Sales Order names backed by the shared API contract.
export const AttachmentDocumentType = DocumentType;
export type AttachmentDocumentType = DocumentType;
export const AttachmentDocumentTypeLabels = DocumentTypeLabels;
export const AttachmentDocumentTypeOptions = DocumentTypeOptions;

export enum SystemRoles {
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  TRAVEL_ADMIN = 'TRAVEL_ADMIN',
  CONTRACT_ADMIN = 'CONTRACT_ADMIN',
  TRAVEL_DESK = 'TRAVEL_DESK',
  TRAVEL_EMPLOYEE = 'TRAVEL_EMPLOYEE',
  CONTRACT_EMPLOYEE = 'CONTRACT_EMPLOYEE',
  CONTRACT_FINANCE = 'CONTRACT_FINANCE',
  TRAVEL_FINANCE = 'TRAVEL_FINANCE',
  HR_ADMIN = 'HR_ADMIN',
  PAYMENT_EMPLOYEE = 'PAYMENT_EMPLOYEE',
  PAYMENT_ADMIN = 'PAYMENT_ADMIN',
  SALES_ORDER_ADMIN = 'SALES_ORDER_ADMIN',
  SALES_ORDER_EMPLOYEE = 'SALES_ORDER_EMPLOYEE',
  SALES_ORDER_FINANCE = 'SALES_ORDER_FINANCE',
  ACTIVITY_EMPLOYEE = 'ACTIVITY_EMPLOYEE',
  ACTIVITY_ADMIN = 'ACTIVITY_ADMIN',
  SO_MASTER_EDIT = 'SO_MASTER_EDIT',
  ADVANCED_PAYMENT_EMPLOYEE = 'ADVANCED_PAYMENT_EMPLOYEE',
  ADVANCED_PAYMENT_ADMIN = 'ADVANCED_PAYMENT_ADMIN',
  SO_DASHBOARD_ADMIN = 'SO_DASHBOARD_ADMIN',
  WAREHOUSE_ADMIN = 'WAREHOUSE_ADMIN',
  ANALYTICS_ADMIN = 'ANALYTICS_ADMIN',
  ANALYTICS_BUILDER = 'ANALYTICS_BUILDER',
  ANALYTICS_VIEWER = 'ANALYTICS_VIEWER',
  PURCHASE_ORDER_ADMIN = 'PURCHASE_ORDER_ADMIN',
  PURCHASE_ORDER_EMPLOYEE = 'PURCHASE_ORDER_EMPLOYEE',
}

export enum ClientCode {
  DEN = 'DEN',
  SAPPHIRE = 'SAPPHIRE',
  HATHWAY = 'HATHWAY',
  SOFTGEL = 'SOFTGEL',
}

export enum ExpenseCategory {
  EMPLOYEE = 'EMPLOYEE',
  OFFICE = 'OFFICE',
}

export enum ActivityStatus {
  PENDING = 'PENDING',
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum ActivityAttachmentDocumentType {
  OTHERS = 'OTHERS',
}

export enum ActivityApprovalStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
}

export const ActivityApprovalStatusOptions = [
  // { label: 'Approved', value: SystemApprovalStatus.APPROVED },
  { label: 'Rejected', value: ActivityApprovalStatus.REJECTED },
  { label: 'Pending', value: ActivityApprovalStatus.PENDING },
];

export const ActivitySubmissionStatusOptions = [
  { label: 'Pending', value: ActivityStatus.PENDING },
  { label: 'In Progress', value: ActivityStatus.INPROGRESS },
  { label: 'Completed', value: ActivityStatus.COMPLETED },
];
